import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHeidelberg() {
  return (
    <CityPageTemplate
      city="Heidelberg"
      slug="heidelberg"
      intro="In der Universitätsstadt Heidelberg beraten wir Berufseinsteiger und Akademiker auf dem Weg zur finanziellen Freiheit."
      description="Unabhängige & digitale Finanzberatung für Heidelberg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
